const isRecord = (value) => typeof value === 'object' && value !== null && !Array.isArray(value);
const readTrimmedString = (record, key) => {
    const value = record[key];
    if (typeof value !== 'string') {
        return '';
    }
    return value.trim();
};
const readNestedFormField = (document, formKey, fieldKey) => {
    const form = document[formKey];
    if (!isRecord(form)) {
        return '';
    }
    return readTrimmedString(form, fieldKey);
};
/**
 * Resolves the company/entity display string for list tables.
 * Prefers nested form fields, then Offer parent ATR nesting, then Resourcing's flattened field.
 */
export const getCompanyCode = (document) => {
    if (!isRecord(document)) {
        return '';
    }
    const formTwoCompanyCode = readNestedFormField(document, 'formTwo', 'company_code');
    if (formTwoCompanyCode !== '') {
        return formTwoCompanyCode;
    }
    const formFourEmployedin = readNestedFormField(document, 'formFour', 'employedin');
    if (formFourEmployedin !== '') {
        return formFourEmployedin;
    }
    const atr = document.atr;
    if (isRecord(atr)) {
        const atrFormTwoCompanyCode = readNestedFormField(atr, 'formTwo', 'company_code');
        if (atrFormTwoCompanyCode !== '') {
            return atrFormTwoCompanyCode;
        }
        const atrFormFourEmployedin = readNestedFormField(atr, 'formFour', 'employedin');
        if (atrFormFourEmployedin !== '') {
            return atrFormFourEmployedin;
        }
    }
    return readTrimmedString(document, 'companyCode');
};
